export default __webpack_public_path__ + "static/image-atm-services-main-v1-960x540-380285077@2x.png";